import { Box, Modal, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { PrintIcon } from "../../../../assets/CommonAssets";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import CommonDynamicTableNew from "../../../../common/components/CommonTable/CommonDynamicTableNew";
import {
  getABGAnalysisListByVisitDate,
  getABGAnalysisVisitDateList,
} from "../../../services/cliinicalChartServices/ABGAnalysisServices";
import ABGAnalysisPrint from "../../../prints/ABGAnalysisPrint";

const ABGAnalysisModal = (props) => {
  const { openABGAnalysisModal, setOpenABGAnalysisModal, patientInfo } = props;
  const [selectedDateIndex, setSelectedDateIndex] = useState(0);
  const [visitDateList, setVisitDateList] = useState([]);
  const [ABGParametersList, setABGParametersList] = useState([]);
  const [openPrintModal, setOpenPrintModal] = useState(false);

  console.log("displayInfo321", patientInfo);

  function formatDateTime(dateStr, timeStr) {
    // Create date objects from both strings
    const dateObj = new Date(dateStr);
    const timeObj = new Date(timeStr);

    // Update the date object with the hours and minutes from the time object
    dateObj.setHours(timeObj.getHours());
    dateObj.setMinutes(timeObj.getMinutes());

    // Manually format the date into dd-MM-yyyy HH:mm AM/PM
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = dateObj.getFullYear();

    let hour = dateObj.getHours();
    const minute = String(dateObj.getMinutes()).padStart(2, "0");
    const period = hour >= 12 ? "PM" : "AM";

    // Convert hour to 12-hour format
    if (hour > 12) {
      hour -= 12;
    } else if (hour === 0) {
      hour = 12; // Midnight case
    }

    // Return formatted string as "dd-MM-yyyy HH:mm AM/PM"
    return `${day}-${month}-${year} ${hour}:${minute} ${period}`;
  }

  const ABGAnalysisByDateAndTime = (date, time) => {
    if (date !== "" && time !== "") {
      getABGAnalysisListByVisitDate({
        admissionId: patientInfo?.AdmissionId,
        date: date,
        time: time,
      }).then((response) => {
        setABGParametersList(
          response?.data?.result?.map((val) => ({
            ...val,
            "Normal Range": `${val.minValue} - ${val.maxValue}`,
          }))
        );
      });
    }
  };

  const renderPrint = () => {
    setTimeout(() => {
      setOpenPrintModal(false);
    }, 1000);

    return (
      <div className="hidden">
        <ABGAnalysisPrint
          ABGParametersList={ABGParametersList}
          patientInfo={patientInfo}
        />
      </div>
    );
  };

  useEffect(() => {
    if (patientInfo) {
      getABGAnalysisVisitDateList(patientInfo?.AdmissionId).then((response) => {
        setVisitDateList(response?.data?.result);
        ABGAnalysisByDateAndTime(
          response?.data?.result[0]?.date,
          response?.data?.result[0]?.time
        );
      });
    }
  }, []);

  console.log("visitDateList321", visitDateList);
  console.log("ABGParametersList321", ABGParametersList);

  return (
    <>
      <Modal open={openABGAnalysisModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "75%",
            minHeight: "50%",
            maxHeight: "95%",
            overflowY: "auto",
            bgcolor: "background.paper",
            border: "1px solid gray",
            boxShadow: 20,
            zIndex: 999,
            p: 2,
          }}
        >
          <div className="flex justify-between">
            <label className="font-semibold">ABG Analysis</label>
            <button
              type="button"
              onClick={() => {
                setOpenABGAnalysisModal(false);
                setABGParametersList([]);
                setVisitDateList([]);
                setSelectedDateIndex(null);
              }}
            >
              <CancelPresentationIconButton />
            </button>
          </div>
          <div className="py-1">
            <hr className="border-t-[1px] border-[#E3E3E5]" />
          </div>
          <div className="grid grid-cols-4 px-2 py-1 border bg-[#F7F9FB] rounded-md text-sm my-2 whitespace-nowrap">
            <div className="flex items-center space-x-2 col-span-2">
              <span className="font-semibold">Patient Name</span>
              <span>&nbsp;:&nbsp;</span>
              <span className="text-customBlue font-bold text-base">
                {patientInfo?.["PatientName"]}
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="font-semibold">MR No</span>
              <span className="text-gray-500">
                &nbsp;:&nbsp;
                {patientInfo?.MRNo}
              </span>
            </div>
            <div className="flex justify-between">
              <div className="flex items-center space-x-2">
                <span className="font-semibold">Age </span>
                <span className="text-gray-500">
                  &nbsp;:&nbsp;
                  {patientInfo?.AgeYear}
                </span>
              </div>
              <Tooltip title="ABG Print">
                <button
                  className="button"
                  onClick={() => {
                    setOpenPrintModal(true);
                  }}
                >
                  <PrintIcon />
                </button>
              </Tooltip>
            </div>
            {/* <div className="flex items-center space-x-2">
              <span className="font-semibold w-14 xl:w-13">Gender </span>
              <span className="text-gray-500">
                :&nbsp;
                {patientInfo?.Gender}
              </span>
            </div> */}
          </div>
          <div className="grid grid-cols-6 gap-x-2">
            <div className="border border-b-gray-100 rounded-xl p-2 space-y-2 bg-[#FFFCFA] h-min">
              <div className="text-customBlue font-semibold">Visit Date</div>
              <div className="py-0.5">
                <hr className="border-t-[1px] border-black" />
              </div>
              <div className="max-h-[350px] 2xl:max-h-[450px] overflow-auto space-y-1">
                {visitDateList?.map((val, index) => (
                  <div
                    className={`${
                      selectedDateIndex === index
                        ? "bg-customBlue text-white"
                        : ""
                    } px-2 py-1 rounded-md cursor-pointer text-sm w-full flex space-x-2 items-center justify-center border border-black`}
                    onClick={() => {
                      if (selectedDateIndex !== index) {
                        setSelectedDateIndex(index);
                        ABGAnalysisByDateAndTime(val?.date, val?.time);
                      }
                      // setSelectedRadioTest(val);
                      // setReportPdf("");
                      // setIsReport(false);
                      // getRadiologytemplates(val?.testId);
                      // setSelectedRadioReportIndex(null);
                    }}
                  >
                    {formatDateTime(
                      val.date?.split("+")[0],
                      val.time?.split("+")[0]
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="overflow-x-auto col-span-5 h-full">
              {ABGParametersList?.length > 0 ? (
                <CommonDynamicTableNew
                  dataResult={ABGParametersList}
                  tableClass={"h-full"}
                  highlightRow={false}
                  removeHeaders={["ParameterId", "maxValue", "minValue"]}
                />
              ) : (
                <div className="font-semibold flex justify-center items-center border rounded h-60">
                  No Records Found...
                </div>
              )}
            </div>
          </div>
        </Box>
      </Modal>
      {openPrintModal && renderPrint()}
    </>
  );
};

export default ABGAnalysisModal;
